import { useQueryParam } from 'use-query-params';
import parseToDateString from '../constants/parseToDateString';
import DateParam from '../utils/DateParam';

const useDateParam = () => {
    const [startDate, setStartDate] = useQueryParam('startDate', DateParam);
    const [selectedEndDate] = useQueryParam('endDate', DateParam);
    if (selectedEndDate) {
        return [
            startDate && startDate === selectedEndDate ? new Date(startDate) : startDate ? new Date(startDate) : null,
            (date: null | Date) => setStartDate(date ? parseToDateString(date) : undefined, 'replaceIn'),
        ] as const;
    }
    return [
        startDate ? new Date(startDate) : null,
        (date: null | Date) => setStartDate(date ? parseToDateString(date) : undefined, 'replaceIn'),
    ] as const;
};

export default useDateParam;
